const TABS = {
  CART: 'CART',
  BUYER_DETAILS: 'BUYER_DETAILS',
  SHIPPING: 'SHIPPING',
  PAYMENT: 'PAYMENT',
};

export default TABS;



// WEBPACK FOOTER //
// ./src/cart/actions/helpers/tabs.js